import React from 'react'
import { Button, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { trackLink } from '@fs/zion-analytics'
import { baseUrl } from '@fs/zion-config'

const hasWindow = typeof window !== 'undefined'

export default function AuthAccount({ external }) {
  const { t } = useTranslation()
  return (
    <Row gutters="xs">
      <Button
        growX
        id="signInLink"
        onClick={() => {
          trackLink(null, '/auth/familysearch/login', 'click_action', 'lo_hdr19_sign_in')
          hasWindow &&
            (window.location.href = `${external ? baseUrl : ''}/auth/familysearch/login?returnUrl=${encodeURIComponent(window.location.href)}`)
        }}
      >
        {t('common-ui:sign-in.action', 'Sign In')}
      </Button>
      <Button
        to={`${external ? baseUrl : ''}/identity/signup/`}
        external
        emphasis="medium"
        linkName="lo_hdr19_register"
        data-test-id="hdr_create_account"
      >
        {t('account.create.action', 'Create Account')}
      </Button>
    </Row>
  )
}
